import React from "react"
import MaterialModal from "../../MaterialModal"
import { Icon } from "antd"
// 如果使用静态图片资源，容易因为断网／网络差的原因造成图片加载失败
// 因此使用 antd 来实现

export default props => (
  <MaterialModal
    width={500}
    visible={props.visible}
    action={props.action}
    title="上传文件失败"
    className="upload-result"
    buttonType="primary"
    buttonText="上传重试">
    <span className="pgx-modal-close close-icon">
      <Icon type="close-circle-o" onClick={props.onCancel} />
    </span>
    <div className="red-circle">
      <Icon type="close-circle" />
    </div>
    <div key="failed-title" className="list-title failed">
      您上传的<span className="span-blue">{props.filesCount}</span>条数据，
      其中<span className="span-red">{props.failedCount}条</span>上传失败</div>
    <div>请检查您的网络后点击下方按钮进行上传重试</div>
  </MaterialModal>
)



// WEBPACK FOOTER //
// ./src/app/components/normal/BasicModal/UploadModal/FailedModal.js